/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getAIModeStatus(conversationID) {
    return axios.get(`${this.url}/${conversationID}/ai_mode_status`);
  }

  toggleAIMode(conversationID, mode = 'ai') {
    return axios.post(`${this.url}/${conversationID}/toggle_ai_mode`, { mode });
  }
}

export default new ConversationApi();
